import type { ReactNode } from 'react';
import { Popover } from '@launchpad-ui/components';

import styles from './Select.module.css';

interface InlineSelectPopoverProps {
  children: ReactNode;
}

export function InlineSelectPopover({ children }: InlineSelectPopoverProps) {
  return (
    <Popover className={styles.popover} placement="bottom left">
      {children}
    </Popover>
  );
}
